/**
 * @generated SignedSource<<646b4295a28c02699e61070563e00699>>
 * @relayHash 61fd1102ea21ffc3d55c97d98b5d58ed
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID app-buyer-finding/442.0.0-2023-12-13T10:06:08.437Z/CheckoutShippingStepQuery

import { ConcreteRequest, Query } from 'relay-runtime';
export type CheckoutShippingStepQuery$variables = {};
export type CheckoutShippingStepQuery$data = {
  readonly viewer: {
    readonly isLoginCaptchaEnabled: boolean | null;
    readonly isLoginCaptchaV3Enabled: boolean | null;
    readonly isRegisterCaptchaEnabled: boolean | null;
  };
};
export type CheckoutShippingStepQuery = {
  response: CheckoutShippingStepQuery$data;
  variables: CheckoutShippingStepQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": "isLoginCaptchaEnabled",
  "args": [
    {
      "kind": "Literal",
      "name": "feature",
      "value": "loginCaptcha"
    }
  ],
  "kind": "ScalarField",
  "name": "featureFlag",
  "storageKey": "featureFlag(feature:\"loginCaptcha\")"
},
v1 = {
  "alias": "isLoginCaptchaV3Enabled",
  "args": [
    {
      "kind": "Literal",
      "name": "feature",
      "value": "loginCaptchaV3"
    }
  ],
  "kind": "ScalarField",
  "name": "featureFlag",
  "storageKey": "featureFlag(feature:\"loginCaptchaV3\")"
},
v2 = {
  "alias": "isRegisterCaptchaEnabled",
  "args": [
    {
      "kind": "Literal",
      "name": "feature",
      "value": "registerCaptcha"
    }
  ],
  "kind": "ScalarField",
  "name": "featureFlag",
  "storageKey": "featureFlag(feature:\"registerCaptcha\")"
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "CheckoutShippingStepQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          (v1/*: any*/),
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "RootQueryType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "CheckoutShippingStepQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          (v1/*: any*/),
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "app-buyer-finding/442.0.0-2023-12-13T10:06:08.437Z/CheckoutShippingStepQuery",
    "metadata": {},
    "name": "CheckoutShippingStepQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "7cb4e49ae87bb4599113e46c3b7f8fa0";

export default node;
